import { render } from "./BaseNotification.vue?vue&type=template&id=e9b19478&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"

import "./BaseNotification.vue?vue&type=style&index=0&id=e9b19478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b19478"]])

export default __exports__